// @flow
import { createAction } from 'redux-actions';
import type { ActionType } from 'types/redux';
import type { Provider } from './ISocial';

export const PROVIDERS_INITIALIZED = 'user/social/PROVIDERS_INITIALIZED';
/**
 * Dispatched after the providers are initialized
 */
const providersInitialized = createAction(
  PROVIDERS_INITIALIZED,
  (status: any) => status
);

export const PARTIAL_SIGN_IN = 'user/social/PARTIAL_SIGN_IN';
/**
 * Dispatched after a successful attempt to sign in through a social provider,
 * this happens after there's a successful match or the user has filled out the
 * information in the additional info form
 */
const partialSignIn = createAction(
  PARTIAL_SIGN_IN,
  (provider: Provider) => provider
);

const actions = {
  partialSignIn,
  providersInitialized
};

export default actions;

export type Action =
  | ActionType<typeof partialSignIn>
  | ActionType<typeof providersInitialized>;



// WEBPACK FOOTER //
// ./src/store/reducers/user/social/actions.js